import { render, staticRenderFns } from "./bracket.vue?vue&type=template&id=71ed5f26&"
import script from "./bracket.vue?vue&type=script&lang=js&"
export * from "./bracket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports